<template>
  <ul class="list-audios" id="top_list_audios">
    <li class="media-list-start">
      <img class="vertical-line-circle" src="../assets/circle.svg">
      <img class="vertical-line-start" src="../assets/line.svg">
    </li>
    <li
      v-for="(audio, i) in $root.media"
      @click.stop="mediaSelected(i)"
      :key="'media_'+i"
      :id="'media_'+$root.floor_selected+'_'+i"
    >
      <div class="list-audios__content">
        <div class="list-audios__icon">
          <img class="audio-icon" src="../assets/head_phones.svg">
          <img
            :class="{'vertical-line-middle':true, 'last-vertical-line':(i==($root.media.length-1))}"
            src="../assets/line.svg"
          >
        </div>
        <div class="list-audios__titlenum">
          <h3>{{audio.num}}</h3>
          <span>{{audio.title}}</span>
          <div
            :class="{
              'private-player-container':true,
              'private-player-container-opened':($root.audio_selected == i)
            }"
          >
            <transition
              enter-active-class="animated slideInDown evenfaster"
              :leave-active-class="leaveActiveClass"
            >
              <AudioPlayer
                v-if="($root.audio_selected == i)"
                :img="getPrivateURL(audio.image)"
                :src="getPrivateURL(audio.audio)"
              ></AudioPlayer>
            </transition>
          </div>
        </div>
      </div>
    </li>
    <li class="media-list-end">
      <img class="vertical-line-circle last-circle" src="../assets/circle.svg">
    </li>
    <li class="spacer" style="height: 6rem;">&nbsp;</li>
  </ul>
</template>

<script>
import AudioPlayer from "@/components/AudioPlayer.vue";

export default {
  name: "ListAudios",
  data() {
    return {
      requesturi: "./remote/",
      cancelScroll: "",
      scrollDelay: "",
      lastFloor: 0
    };
  },
  computed: {
    leaveActiveClass: function() {
      let str = "animated slideOutUp ";
      if (!this.closingPage()) str += "evenfaster";
      else str += "instant";
    }
  },
  events: {
    "update-scroll-position": function() {
      scrollToElement();
    }
  },
  methods: {
    mediaSelected: function(n) {
      if (this.$root.audio_selected == n) {
        this.$root.audio_selected = -1;
      } else {
        this.$root.audio_selected = n;
        // Scroll animation
        var __this = this;
        this.scrollDelay = setTimeout(function() {
          __this.scrollToElement();
        }, 500);
      }
    },
    scrollToElement: function() {
      this.cancelScroll = this.$scrollTo(
        "#media_" + this.$root.floor_selected + "_" + this.$root.audio_selected,
        250,
        {
          container: "#audioList",
          offset: -10,
          easing: "ease-in",
          x: false
        }
      );
    },
    closingPage: function() {
      if (this.lastFloor != this.$root.floor_selected) {
        this.lastFloor = this.$root.floor_selected;
        if (this.cancelScroll != "") {
          this.cancelScroll();
        }
        if (this.scrollDelay != "") {
          clearTimeout(this.scrollDelay);
        }
        this.cancelScroll = this.$scrollTo("#top_list_audios", -1, {
          container: "#audioList",
          offset: -2000,
          x: false
        });
        return true;
      }
      return false;
    },
    getPrivateURL: function(url) {
      return this.requesturi + url;
    }
  },
  beforeDestroy: function() {
    if (this.cancelScroll != "") {
      this.cancelScroll();
    }
    if (this.scrollDelay != "") {
      clearTimeout(this.scrollDelay);
    }
    this.$root.audio_selected = -1;
    this.$root.floor_selected = 0;
  },
  components: {
    AudioPlayer
  }
};
</script>